module.exports = __webpack_public_path__ + "img/foove-logo.c1c91be7.svg";